import React from "react";
import {Form} from 'react-bootstrap';

function STCFormLabel(props){

    return(
        <Form.Label
            style={props.style}
            className={props.className}

            ref={props.ref}
            as={props.as}
            column={props.column}
            htmlFor={props.htmlFor}
            visuallyHidden={props.visuallyHidden}
            bsPrefix={props.bsPrefix}
            size={props.size}

            sm={props.sm}
        >
            {props.children}
        </Form.Label>
    )
}
export default STCFormLabel;